module.exports = __webpack_public_path__ + "img/icon-arrow-left.0efab4df.svg";